import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import VideosSettings from "./VideosSettings";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import { message, Input, Button, Row, Col } from "antd";
import ContentPageTitle from "../../../../common/ContentPageTitle";

//** Import Components */
import { useManageVideosValidate } from "../../../../hooks/useManageVideosValidate";

export default function VideosPendingApproval(props) {
  const { user } = props;

  const [searchInput, setSearchInput] = useState("");
  const [businessVideos, setBusinessVideos] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [businessID, setBusinessID] = useState(null);
  const [businessName, setBusinessName] = useState("Default Name");

  const handleSearchBusinessVideos = async () => {
    if (!searchInput.trim()) {
      message.warning("Please enter a value to search");
      return;
    }

    setIsSearching(true);
    try {
      const response = await axiosWithAuth().get(
        `${
          process.env.REACT_APP_BE_API_URL
        }/api/business/media/list/${searchInput.trim()}`
      );
      console.log("Full response:", response.data);
      console.log("MediaList:", response.data.mediaList);
      console.log("Videos data:", response.data.mediaList?.data);

      setBusinessVideos(response.data.mediaList?.data || []);
      setBusinessID(response.data.businessID);
      // TODO: Replace with actual business name from API response
      setBusinessName(response.data.businessName || "Default Name");
      message.success(
        `Found ${
          response.data.mediaList?.data?.length || 0
        } videos for this business`
      );
    } catch (error) {
      console.log(error);
      message.error("Business not found with the provided FEI/EIN number");
      setBusinessVideos([]);
      setBusinessID(null);
      setBusinessName("Default Name");
    } finally {
      setIsSearching(false);
    }
  };

  const [modalComponent, CreateItemButton, VideosListComponent] =
    useManageVideosValidate({
      refreshData: handleSearchBusinessVideos,
    });

  return (
    <>
      <ContentPageTitle title="Manage Videos" icon="video" />
      <div className="content-box">
        {/* Search Section */}
        <div
          style={{
            marginBottom: "20px",
            padding: "16px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          <Row gutter={16} align="middle">
            <Col flex="auto">
              <Input
                placeholder="FEI/EIN Number"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onPressEnter={handleSearchBusinessVideos}
                size="large"
              />
            </Col>
            <Col>
              <Button
                type="primary"
                onClick={handleSearchBusinessVideos}
                loading={isSearching}
                size="large"
              >
                Search
              </Button>
            </Col>
          </Row>
        </div>

        {/* Business Info and Video Creation Section - Show when business is found */}
        {businessID && (
          <div style={{ marginBottom: "30px" }}>
            {/* Business Name */}
            <div style={{ marginBottom: "20px" }}>
              <h3 style={{ margin: 0, color: "#1890ff", fontWeight: "600" }}>
                {businessName}
              </h3>
            </div>

            {/* Add Video Button */}
            <div style={{ marginBottom: "20px" }}>
              {businessVideos.length < 5 ? (
                <CreateItemButton
                  btnText="Create New Video to Promote"
                  businessID={businessID}
                />
              ) : (
                <div style={{ color: "#ff4d4f", fontWeight: "500" }}>
                  Maximum number of video promotions reached (5/5)
                </div>
              )}
            </div>
          </div>
        )}

        {/* Business Videos Section */}
        <div>
          <VideosListComponent
            emptyMessage="No videos found for this business. Create your first video promotion above."
            listItems={businessVideos}
          />
        </div>

        <Routes>
          <Route path="/" element={<></>} exact />

          <Route path="/:id" element={<VideosSettings />} exact />
        </Routes>
      </div>

      {modalComponent}
    </>
  );
}
